<template>
  <!-- hero banner -->
  <div :class="mclass !== '' ? mclass : 'hero-banner'">
    <!-- NON FULL WIDTH -->
    <div class="container" v-if="section_display_as==''">
      <text-image v-if="type == 'textimage'"
        :rclass = rclass
        :cmlass = cmlass
        :lmclass = lmclass
        :rmclass = rmclass
        :show_goal_count = show_goal_count
        :show_cta = show_cta
        :heading = heading
        :hmclass = hmclass
        :heading_class = heading_class
        :image = image
        :body = body
        :body_class = body_class
        :cta = cta
        :lazy= lazy
      >
      </text-image>

      <image-text v-if="type == 'imagetext'"
        :rclass = rclass
        :cmlass = cmlass
        :lmclass = lmclass
        :rmclass = rmclass
        :show_goal_count = show_goal_count
        :show_cta = show_cta
        :heading = heading
        :hmclass = hmclass
        :heading_class = heading_class
        :image = image
        :body = body
        :body_class = body_class
        :cta = cta
        :lazy= lazy
      >
      </image-text>
    </div>

    <!-- FULL WIDTH -->
    <div class="container" v-if="section_display_as=='fullwidth'">
      <div class="row"> <!--only if fullwidth -->
        <div class="col-sm-12">  <!--only if fullwidth -->
          <div class="banner-outer"> <!--only if fullwidth -->
              <text-image  v-if="type == 'textimage'"
              :rclass = rclass
              :cmlass = cmlass
              :lmclass = lmclass
              :rmclass = rmclass
              :show_goal_count = show_goal_count
              :show_cta = show_cta
              :heading = heading
              heading_class = heading_class
              type = type
              :image = image
              :body = body
              :body_class = body_class
              :cta = cta
              :lazy= lazy
            >
            </text-image>

            <image-text v-if="type == 'imagetext'"
              :rclass = rclass
              :cmlass = cmlass
              :lmclass = lmclass
              :rmclass = rmclass
              :show_goal_count = show_goal_count
              :show_cta = show_cta
              :heading = heading
              heading_class = heading_class
              type = type
              :image = image
              :body = body
              :body_class = body_class
              :cta = cta
              :lazy= lazy
            >
            </image-text>
          </div>
        </div>
      </div>
    </div>
  </div>
	<!-- end hero banner -->
</template>

<script>
export default {
  props: {
    section_display_as: { type:String, default:'' },
    //classes
    //===========================================
    mclass: { type:String, default:'' }, // main class
    // Inner component property
    rclass: { type:String, default:'' }, // row class
    cmlass: { type:String, default:'' }, // row class
    lmclass: { type:String, default:'' }, // left main class
    rmclass: { type:String, default:'' }, // right main class
    show_goal_count: { type:Boolean, default:false },
    
    // Display properties
    heading: { type:String, default:'' },
    hmclass : { type:String, default:'' }, // heading main class
    heading_class: { type:String, default:'' },
    type: { type:String, default:'imagetext' }, //imagetext, textimage, texttext, imageimage
    image: { type: Object, required:true },
    body: { type: String, default:''},
    body_class: { type: String, default:''},
    cta: { type: Object, default:{} },
    show_cta: { type: Boolean, default: true },
    lazy:{ type:Boolean, default:false },
  },
}

</script>
